import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getEdById, getProp } from '../../actions'
import { useParams } from 'react-router-dom'
import video from '../../fondo/video.mp4'
import PDF from '../PDF/PDF'
import bloque from '../../fondo/Bloque.png'
import { PDFViewer } from '@react-pdf/renderer'
import './Client.css'
import { Button } from '@mui/material'

function Client() {

  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const myClient = useSelector((state) => state.propietarios)
  const myEdificio = useSelector((state) => state.edificio)
  let [gasto, setgasto] = useState(false)
  let [expensa, setexpensa] = useState(true)



  const { propietarios } = useParams()
  useEffect(() => {
    dispatch(getProp(propietarios))
  }, [])

  // console.log(gasto,'m')
  const handleEd = () => {
    setgasto(!gasto)
    setexpensa(true)

  }
  const handleEd2 = () => {
    setexpensa(!expensa)
    setgasto(false)
  }

  return (
    <div>
      {
        myClient.length > 0 ?
          <div style={{ padding: "10px", background: "#103e52", height: "97vh" }}>
            <div className='div' style={{ display: "flex", justifyContent: "flex-start" }}>
              <div className='sombra'>

                <img src={bloque} alt="bloque" style={{ width: "30%" }} />
              </div>
            </div>
            <h5>Propietario: {myClient[0].propietarios}</h5>
            <h3>Expensas: ${myClient[0].expensas}</h3>
            <h5>PLANILLA DE GASTOS: Marzo 2023</h5>
            {
              gasto === false ?
                <div className='caja-btn'>
                  <Button variant="contained" onClick={handleEd}>
                    VER PDF
                  </Button>
                </div>

                :
                <div className='PDF'>
                  <PDFViewer style={{ width: "80%", height: "60vh" }}>
                    <PDF />
                  </PDFViewer>
                </div>
            }


          </div>
          :
          <>

          </>

      }
    </div>
  )
}

export default Client